module.exports = __webpack_public_path__ + "img/things2.52d1848f.png";